import styled from 'styled-components'
import {
  ANATOMY_COMPACT,
  anatomyCompact,
} from '~/pages/anatomy/libs/responsive'
import {
  anatomyBodyCss,
  anatomyH1Css,
  anatomyRootCss,
  anatomyStickyButtonCss,
} from '~/pages/anatomy/libs/styles'
import { Button } from '~/shared/components/Button'
import { Container } from '~/shared/components/Container'

export const HistoryInfoPageStyles = {
  Root: styled.div`
    ${anatomyRootCss}
  `,

  StyledContainer: styled(Container)`
    padding: 24px 16px;
    height: 100%;

    ${anatomyCompact} {
      overflow-y: auto;
    }
  `,

  ImageWrapper: styled.div`
    max-width: 100%;

    picture {
      display: block;
      width: 100%;
    }

    img {
      max-width: 100%;
      width: 100%;
      display: block;
    }
  `,

  Title: styled.h1`
    ${anatomyH1Css}
    margin-top: 16px;
    margin-bottom: 16px;

    ${anatomyCompact} {
      font-size: ${ANATOMY_COMPACT.fontSize.f22};
      line-height: ${ANATOMY_COMPACT.lineHeight.lh28};
    }
  `,

  Subtitle: styled.p`
    ${anatomyBodyCss}
    text-align: justify;
    margin-bottom: 16px;
  `,

  StyledButton: styled(Button)`
    ${anatomyStickyButtonCss}
  `,
} as const
